import React, { Component } from 'react';
import { connect } from 'react-redux';
import Loader from 'react-loader';
import { getFormValues } from 'redux-form';
import { Container } from 'reactstrap';
import Layout from '../components/Layout';
import PageNav from '../components/PageNav';
import AboutForm from '../modules/AboutForm';
import { fetchAboutDetail } from '../modules/AboutDetail/actions';
import { isLoaded, getError } from '../modules/AboutDetail/selectors';
import { ABOUT_FORM_NAME } from '../modules/AboutForm/constants';

class EditAboutPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false
    };

    this.toggle = this.toggle.bind(this);
  }

  componentDidMount() {
    const { id, lang } = this.props.match.params;
    this.props.fetchAboutDetail(id, lang);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }

  getConfig = () => {
    const { state } = this.props.location;
    if (!state) {
      return undefined;
    } else {
      return state;
    }
  };

  render() {
    const { isLoaded, aboutInitialValues, match } = this.props;
    const { lang } = match.params;

    const initialValues = { ...aboutInitialValues, lang };

    return (
      <Layout>
        <Container>
          <Loader loaded={isLoaded}>
            <PageNav>
              <h1>Upravit stránku o klinice</h1>
            </PageNav>
            <AboutForm
              config={this.getConfig()}
              initialValues={initialValues}
            />
          </Loader>
        </Container>
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  return {
    aboutInitialValues: getFormValues(ABOUT_FORM_NAME)(state),
    isLoaded: isLoaded(state),
    error: getError(state)
  };
};

export default connect(
  mapStateToProps,
  { fetchAboutDetail }
)(EditAboutPage);



// WEBPACK FOOTER //
// ./src/pages/EditAboutPage.js